import type { FaireProductEntity } from "../../entity_types/product";

export const p_92qptjf4jk: FaireProductEntity = {
  token: "p_92qptjf4jk",
  type: "product",
  name: "Felted Wool Corn Dog Toy",
  brandToken: "b_f9031f62",
  brandName: "Ware of the Dog",
  imageUrl: "https://cdn.faire.com/fastly/de80e893c99683deccd59c6e15ec7fe447810763bbeb78a3d3bbf0d533534ed5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bbd286dea84bbbc8b1ea2a5f8233549d43ccbc2aeb19bbc645b439569fa9eea.jpeg"
  ],
  priceDollars: 9,
  description: "Part of our playful food themed toy collection. \n• 100% wool\n• Hand made through felting\n• This is a fair-trade product which provides employment to craftswomen in Nepal",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:07:00.206Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
